import React from 'react';
import { Link } from 'react-router-dom';
import './Card.css';
import ImagePlaceHolder from 'assets/placeholder.png';
import { createPath, ROUTE } from 'utils/Routing';

type CardProps = {
  image: string;
  title: string;
  id: string;
};

const Card = ({ image, title, id }: CardProps) => {
  return (
    <div className='side__content-card'>
      <Link to={createPath({ path: ROUTE.GAME_PAGE, params: { gameID: id } })}>
        <div className='card__content'>
          <img src={image || ImagePlaceHolder} alt='' srcSet='' className='post__image' />
          <div className='gradient' />
          <p className='side__content-card-title'>{title}</p>
        </div>
      </Link>
    </div>
  );
};

export default Card;
